// src/components/auth/AuthLayout.js
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Bot as BotIconLucide } from 'lucide-react'; // Lub inna ikona logo
import { Logo as StyledLogo } from '../main/CommonStyles'; // Załóżmy, że Logo jest w CommonStyles

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: ${({ theme }) => theme.colors.background}; // Delikatne tło z motywu
    padding: ${({ theme }) => theme.spacing.md};
    font-family: ${({ theme }) => theme.fonts.main};

    @media (min-width: 768px) {
        // Można dodać np. tło gradientowe lub obrazek dla większych ekranów
        // background: linear-gradient(135deg, ${({ theme }) => theme.colors.primaryLightest} 0%, ${({ theme }) => theme.colors.backgroundLight} 100%);
    }
`;

const AuthCard = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    padding: ${({ theme }) => theme.spacing.xl};
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: ${({ theme }) => theme.shadows.xl}; // Wyraźniejszy cień
    width: 100%;
    max-width: 480px; // Trochę szersza karta
    text-align: center;
    border-top: 5px solid ${({ theme }) => theme.colors.primary}; // Akcent kolorystyczny na górze
`;

const LogoLink = styled(Link)`
    display: inline-flex; // Aby wyśrodkować StyledLogo
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    text-decoration: none;
`;

const AppTitle = styled.h1`
    font-size: 2rem; // Większy tytuł aplikacji przy logo
    color: ${({ theme }) => theme.colors.primaryDarker};
    font-weight: 700;
    margin-left: ${({ theme }) => theme.spacing.sm};
`;

const PageTitle = styled.h2`
    font-size: 1.75rem; // Tytuł "Logowanie" / "Rejestracja"
    color: ${({ theme }) => theme.colors.textDark};
    margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

const PageSubtitle = styled.p`
    font-size: 0.95rem;
    color: ${({ theme }) => theme.colors.textMedium};
    margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

const AuthFooter = styled.div`
    margin-top: ${({ theme }) => theme.spacing.xl};
    font-size: 0.8rem;
    color: ${({ theme }) => theme.colors.textMedium};

    a {
        color: ${({ theme }) => theme.colors.primary};
        text-decoration: none;
        font-weight: 500;
        &:hover {
            text-decoration: underline;
        }
    }
    p {
        margin-bottom: ${({ theme }) => theme.spacing.xs};
    }
`;

const AuthLayout = ({ children, title, subtitle }) => {
    return (
        <PageWrapper>
            <AuthCard>
                <LogoLink to="/">
                    <StyledLogo> {/* Twoje istniejące StyledLogo */}
                        <BotIconLucide size={40} /> {/* Większa ikona */}
                        <AppTitle>ePsycholog</AppTitle>
                    </StyledLogo>
                </LogoLink>

                <PageTitle>{title}</PageTitle>
                {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}

                {children} {/* Tutaj będzie wstawiony formularz logowania/rejestracji */}

                <AuthFooter>
                    <p>
                        <Link to="/">Wróć na stronę główną</Link>
                    </p>
                    <p>
                        &copy; {new Date().getFullYear()} ePsycholog. Wszelkie prawa zastrzeżone.
                    </p>
                </AuthFooter>
            </AuthCard>
        </PageWrapper>
    );
};

export default AuthLayout;